import { render, staticRenderFns } from "./pointEdit.vue?vue&type=template&id=9921bc48&scoped=true&"
import script from "./pointEdit.js?vue&type=script&lang=js&"
export * from "./pointEdit.js?vue&type=script&lang=js&"
import style1 from "./pointEdit.vue?vue&type=style&index=1&id=9921bc48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9921bc48",
  null
  
)

export default component.exports